import { UserPaymentTransactionLimited } from "@api-types/account-settings/UserPaymentTransactionLimited";
import { httpClient } from "@utils";
import { getApiRequestContext } from "@utils/api-config";
import { getApplicationRequestHeaders } from "@utils/api-config/getApplicationRequestHeader";
import { ApiRequestContextData, ContextOptions } from "@utils/api-config/types";

export class UserPaymentTransactionsApiService {
	static baseUrl(config: ApiRequestContextData): string {
		return `${WEBPACK_BASE_PROXY_ADDRESS}${config?.agencyKey}/user-payment-transactions`;
	}

	static getRequestHeaders = (config: ApiRequestContextData) => {
		const appHeaders = getApplicationRequestHeaders(config);
		appHeaders["Content-Type" as keyof HeadersInit] = "application/json";
		return appHeaders;
	};

	// TODO same as payment transaction
	static async getTransactionDetails(
		transactionId: string,
		options: ContextOptions
	): Promise<UserPaymentTransactionLimited> {
		const config = getApiRequestContext(options);
		const url = `${this.baseUrl(config)}/foruser/${transactionId}?embed=paymentMethod,currency,transactionStatus&translate=true`;

		return await httpClient.get(url, this.getRequestHeaders(config));
	}
}
